<div class="message-history-container mat-elevation-z8">
  <ng-container *ngIf="loading">
    <mat-spinner [diameter]="50" color="primary"></mat-spinner>
  </ng-container>
  <ng-container *ngIf="!loading">
    <div *ngIf="hasNotifications; else noMessages">
      <div class="message-card" *ngFor="let message of filteredNotifications">
        <mat-card>
          <mat-card-header>
            <div class="message-header">
              <mat-icon>message</mat-icon>
              <span class="message-sender">System</span>
              <span class="message-date">{{ message.date }} {{ message.time }}</span>
            </div>
          </mat-card-header>
          <mat-card-content>
            <p>{{ message.message }}</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <ng-template #noMessages>
      <div class="no-messages">
        <mat-icon>info</mat-icon>
        No notifications found.
      </div>
    </ng-template>
  </ng-container>
</div>
